<template>
  <div class="works">
    <div class="wrapper">
      <h2 class="big-title big-title--no-p">أعمالنا</h2>
      <ul class="categories">
        <li v-for="(cat, i) in categories" :key="i" v-text="cat" @click="category = cat" :style="category === cat ? {fontWeight: 'bold'}:''"></li>
      </ul>
      <transition-group name="cards" tag="div" class="cards">
        <router-link class="card" v-for="project in filtered" :key="project.slug" :to="{ name: 'Project', params: { slug: project.slug} }">
          <img class="card__img" :src="getImgUrl(project.featured)" alt="very cool bg">
          <div class="card__info">
            <h4 class="card__title"><span v-text="project.title"></span></h4>
            <p class="card__category"><span v-text="project.category"></span></p>
          </div>
        </router-link>
      </transition-group>
    </div>
  </div>
</template>

<script>
import Projects from '@/data/projects'

export default {
  data () {
    return {
      projects: Projects,
      category: 'الكل',
      categories: [
        'الكل',
        'تصميم',
        'تصوير'
      ]
    }
  },
  computed: {
    filtered () {
      return this.projects.filter(project => project.category === this.category || this.category === 'الكل')
    }
  },
  methods: {
    getImgUrl (img) {
      var images = require.context('@/assets/', false, /\.jpg$/)
      return images('./' + img + '.jpg')
    }
  }
}
</script>

<style lang="scss">
.categories {
  margin: 4rem 0;

  li {
    display: inline-block;
    padding: 0 .5rem;
    // font-family: Montserrat Bold;
    text-transform: uppercase;
    cursor: pointer;
    transition: background-color 1s cubic-bezier(.43,.26,.13,1.01);
  }
}

.cards {
  display: grid;
  grid-gap: 2rem;
  margin-bottom: 4rem;

  @media screen and (min-width: 640px) {
    display: grid;
    grid-template-columns: repeat(2,1fr);
    margin-bottom: 4rem;
  }

  @media screen and (min-width: 960px) {
    grid-gap: 4rem;
  }

  > span {
    display: contents;
  }
}

.cards-enter {
  transform: scale(0.5) translatey(-80px);
  opacity:0;
}

.cards-leave-to{
  transform: translatey(30px);
  opacity:0;
}

.cards-leave-active {
  position: absolute;
  z-index:-1;
}

.card {
  position: relative;
  display: block;
  overflow: hidden;
  cursor: pointer;
  height: 400px;
  transition: all .35s ease-in-out;

  .card__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    // height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: 50% 50%;
    object-position: 50% 50%;
  }

  .card__info {
    position: absolute;
    z-index: 9;
    bottom: 0;
    right: 0;
    margin: 2rem;
    pointer-events: none;
    color: #fff;

    @media screen and (min-width: 960px) {
      color: #fff;
    }
  }

  .card__title {
    margin-bottom: 0;

    span {
      @media screen and (min-width: 960px) {
        display: inline-block;
        transform: translateY(100%);
        transition: transform .75s cubic-bezier(.43,.26,.13,1.01);
      }
    }

    @media screen and (min-width: 960px) {
      overflow: hidden;
    }
  }

  .card__category {
    font-size: 1.25rem;
    margin-bottom: 0;

    span {
      @media screen and (min-width: 960px) {
        display: inline-block;
        transform: translateY(100%);
        transition: transform .5s cubic-bezier(.43,.26,.13,1.01);
      }
    }

    @media screen and (min-width: 960px) {
      overflow: hidden;
    }
  }

  &:hover {
    .card__title {
      span {
        @media screen and (min-width: 960px) {
          transform: translateY(0);
        }
      }
    }

    .card__category {
      span {
        transform: translateY(0);
      }
    }
  }

}
</style>
